/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Chat_Steps_Reasoning_CountInputs */



/**
* | output |
* | --- |
* | "{count} reasoning steps" |
*
* @param {Chat_Steps_Reasoning_CountInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_steps_reasoning_count = /** @type {((inputs: Chat_Steps_Reasoning_CountInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Steps_Reasoning_CountInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} Überlegungsschritte`)
	return /** @type {LocalizedString} */ (`${i?.count} reasoning steps`)
});